
define(
	'jsx!components/loadingindicator',[
	"jquery",
	"underscore",
	"backbone",
	"react"
	],
	function($,_,Backbone,React){
		return React.createClass({
			displayName: "LoadingIndicator",
			getInitialState : function() {
				return {
					width : this.props.dimensions ? this.props.dimensions.width : 100,
					height : this.props.dimensions ? this.props.dimensions.height : 100
				}
			},
			render: function() {
				var loadingIndicator = (React.createElement("div", {style: this.props.style, className: "loading-indicator"}, 
					React.createElement("svg", {width: this.state.width, height: this.state.height}, 
						React.createElement("circle", {r: this.state.width/2 - 4, cx: this.state.width/2, cy: this.state.width/2}
						)
					)
				));

				if(this.props.withBackground) {
					return (React.createElement("div", {className: "loading-indicator-background"}, 
						loadingIndicator
					));
				}

				return loadingIndicator;
			}
		});
	}
);
